// eslint-disable-next-line import/prefer-default-export
export const UkgDateFormat = Object.freeze({
    ShortDate: 0,
    ShortDateTime: 1,
    LongDate: 2,
    LongDateTime: 3,
    TimeFormat: 4,
});
